import { render } from "./DoctorsList.vue?vue&type=template&id=d26a53f6&scoped=true"
import script from "./DoctorsList.vue?vue&type=script&lang=ts"
export * from "./DoctorsList.vue?vue&type=script&lang=ts"

import "./DoctorsList.vue?vue&type=style&index=0&id=d26a53f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d26a53f6"

export default script